import React from "react";
import PropTypes from "prop-types";
import Map, { Marker } from "theme/components/organisms/Map";
import {
  CoordinatesShape,
  LocationInputShape,
} from "theme/components/organisms/Map/location";

/**
 * @type {React.FC<MapProps>}
 */
const PageBuilderMap = ({ data, "data-pb-style": styleId, className }) => {
  const { zoom, locations, defaultCenter, defaultBounds } = data;

  const MapFragment = locations?.[0] ? (
    <Map
      zoom={zoom}
      locations={locations}
      defaultCenter={defaultCenter}
      defaultBounds={defaultBounds}
      getMarker={(location) => <Marker key={location.id} location={location} />}
    />
  ) : null;

  return (
    <div className={className} data-pb-style={styleId}>
      {MapFragment}
    </div>
  );
};

/** @typedef {PropTypes.InferProps<typeof propTypes>} MapProps*/
const propTypes = {
  data: PropTypes.shape({
    dataId: PropTypes.string,
    appearance: PropTypes.string,
    locations: PropTypes.arrayOf(LocationInputShape).isRequired,
    showControls: PropTypes.bool,
    defaultBounds: PropTypes.arrayOf(CoordinatesShape),
    defaultCenter: CoordinatesShape,
    zoom: PropTypes.number,
  }),
  "data-pb-style": PropTypes.string,
  className: PropTypes.string,
};

PageBuilderMap.propTypes = propTypes;

export default PageBuilderMap;
